<script>
import ConversaCard from './ConversaCard.vue';

export default {
  name: 'EstagioColumn',
  components: { ConversaCard },
  props: {
    estagio: { type: Object, required: true },
    conversas: { type: Array, default: () => [] },
  },
  emits: ['cardClick', 'drop'],
  data() { return { isOver: false }; },
  methods: {
    onDragOver(event) { event.preventDefault(); event.dataTransfer.dropEffect = 'move'; this.isOver = true; },
    onDragLeave() { this.isOver = false; },
    onDrop(event) {
      event.preventDefault();
      this.isOver = false;
      const conversaId = Number(event.dataTransfer.getData('text/plain'));
      if (!conversaId) return;
      this.$emit('drop', { conversaId, estagioId: this.estagio.id });
    },
  },
};
</script>

<template>
  <div
    class="estagio-column"
    :class="{ 'is-over': isOver }"
    @dragover="onDragOver"
    @dragleave="onDragLeave"
    @drop="onDrop"
  >
    <header class="estagio-header" :style="{ borderTopColor: estagio.cor || '#878a99' }">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <span class="dot" :style="{ background: estagio.cor || '#878a99' }"></span>
          <strong>{{ estagio.nome }}</strong>
        </div>
        <span class="badge estagio-count-badge">{{ conversas.length }}</span>
      </div>
    </header>

    <div class="estagio-body">
      <div v-if="!conversas.length" class="text-center text-muted small py-3 fst-italic">
        Vazio
      </div>
      <ConversaCard
        v-for="c in conversas"
        :key="c.id"
        :conversa="c"
        @click="$emit('cardClick', $event)"
      />
    </div>
  </div>
</template>

<style scoped>
.estagio-column {
  display: flex;
  flex-direction: column;
  flex: 0 0 280px;
  width: 280px;
  background: var(--vz-tertiary-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.5rem;
  margin-right: 0.75rem;
  height: 100%;
  transition: background 0.15s;
}
.estagio-column.is-over {
  background: rgba(var(--vz-primary-rgb), 0.12);
  outline: 2px dashed var(--vz-primary);
  outline-offset: -2px;
}
.estagio-header {
  padding: 0.6rem 0.75rem;
  border-top: 4px solid;
  border-radius: 0.5rem 0.5rem 0 0;
  background: var(--vz-body-bg);
  color: var(--vz-body-color);
}
.estagio-count-badge {
  background: var(--vz-secondary-bg);
  color: var(--vz-body-color);
  font-weight: 600;
}
.estagio-body {
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem;
}
.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
</style>
